document.addEventListener('DOMContentLoaded', function () {
  var form = document.querySelector('.product-single__meta form.product-form');
  if (!form || !window.location.pathname.includes('/products/smile-pro-ergonomic-chair')) return;

  // The consent notice belongs to the page top; keep the fixed header at the
  // viewport edge after the notice has scrolled away.
  function syncCookieHeader() {
    document.body.classList.toggle('smile-pro-cookie-scrolled', window.scrollY > 4);
  }
  window.addEventListener('scroll', syncCookieHeader, { passive: true });
  syncCookieHeader();

  // The Black white-background media is omitted from this demo's gallery.
  var omittedMediaId = '34541349666993';
  document.querySelectorAll([
    '.product-single__media-group > .swiper-slide[data-count="' + omittedMediaId + '"]',
    '[data-product-thumbnails] > .swiper-slide[data-count="' + omittedMediaId + '"]',
    '.mySwiper3 .swiper-wrapper > .swiper-slide[data-count="' + omittedMediaId + '"]',
    '.media--modal__sidebar li[data-count="' + omittedMediaId + '"]'
  ].join(',')).forEach(function (slide) { slide.remove(); });

  // Keep the Smile Pro gallery usable even when the theme's thumbnail Swiper
  // receives a tap without advancing the main Swiper on touch devices.
  var mainGallery = document.querySelector('.mySwiper2');
  var thumbnailTrack = document.querySelector('[data-product-thumbnails]');
  function mainSwiper() { return mainGallery && mainGallery.swiper; }
  function slideIndexFor(thumbnail) {
    var count = thumbnail.getAttribute('data-count');
    var slides = mainGallery && mainGallery.querySelectorAll('.product-single__media-group > .swiper-slide');
    if (!slides) return -1;
    return Array.prototype.findIndex.call(slides, function (slide) {
      return slide.getAttribute('data-count') === count;
    });
  }
  if (thumbnailTrack && mainGallery) {
    thumbnailTrack.addEventListener('click', function (event) {
      var thumbnail = event.target.closest('.swiper-slide');
      if (!thumbnail || !thumbnailTrack.contains(thumbnail)) return;
      var index = slideIndexFor(thumbnail);
      if (index < 0) return;
      event.preventDefault();
      event.stopPropagation();
      var swiper = mainSwiper();
      if (swiper) swiper.slideTo(index);
    }, true);

    var gesture = null;
    var suppressGalleryClickUntil = 0;
    mainGallery.addEventListener('touchstart', function (event) {
      if (window.innerWidth >= 768 || event.touches.length !== 1) return;
      var touch = event.touches[0];
      gesture = { x: touch.clientX, y: touch.clientY, index: mainSwiper()?.activeIndex || 0 };
    }, { capture: true, passive: true });
    mainGallery.addEventListener('touchend', function (event) {
      if (!gesture || window.innerWidth >= 768 || !event.changedTouches.length) return;
      var touch = event.changedTouches[0];
      var dx = touch.clientX - gesture.x;
      var dy = touch.clientY - gesture.y;
      var startIndex = gesture.index;
      gesture = null;
      if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.2) return;
      suppressGalleryClickUntil = Date.now() + 500;
      requestAnimationFrame(function () {
        var swiper = mainSwiper();
        if (!swiper) return;
        // The theme's touch handler can jump back to the first slide on iOS;
        // the gesture's starting slide is the stable source of truth here.
        swiper.slideTo(Math.max(0, Math.min(swiper.slides.length - 1, startIndex + (dx < 0 ? 1 : -1))));
      });
    }, { capture: true, passive: true });
    mainGallery.addEventListener('touchcancel', function () { gesture = null; }, { passive: true });
    mainGallery.addEventListener('click', function (event) {
      if (Date.now() >= suppressGalleryClickUntil) return;
      event.preventDefault();
      event.stopImmediatePropagation();
    }, true);
  }

  var mediaColumn = document.querySelector('.product .product__media-wrapper');
  var benefitsAccordion = Array.prototype.find.call(document.querySelectorAll('.product__accordion'), function (accordion) {
    return /features and benefits/i.test(accordion.querySelector('.product__accordion-title-heading')?.textContent || '');
  });
  if (mediaColumn && benefitsAccordion && !document.querySelector('.smile-pro-trust-marks')) {
    var marks = document.createElement('div');
    marks.className = 'smile-pro-trust-marks';
    marks.setAttribute('aria-label', 'Certification marks');
    marks.innerHTML = [
      ['135', 'IGR — Institut für Gesundheit und Ergonomie'],
      ['327', 'Prüfengel — The German Institute for Product Testing'],
      ['515', 'TÜV Rheinland — ID 1111292061'],
      ['937', 'BIFMA']
    ].map(function (mark) {
      return '<span class="smile-pro-trust-mark" role="img" aria-label="' + mark[1] + '" style="--crop-x:' + mark[0] + '"></span>';
    }).join('');
    function positionTrustMarks() {
      if (window.innerWidth < 768) {
        benefitsAccordion.insertAdjacentElement('afterend', marks);
      } else {
        mediaColumn.appendChild(marks);
      }
    }
    positionTrustMarks();
    window.addEventListener('resize', positionTrustMarks, { passive: true });
  }

  var hero = document.querySelector('[data-smile-hero-main]');
  function sizedSmileAsset(src, width) {
    return src.replace(/(\.[^./?]+)(\?[^#]*)?$/, '_' + width + 'x$1$2');
  }
  function smileHeroSources(src) {
    return [375, 640, 900, 1254].map(function (width) {
      return sizedSmileAsset(src, width) + ' ' + width + 'w';
    }).join(', ');
  }
  function syncHero() {
    if (!hero) return;
    var selectedColour = form.querySelector('.product_swatches input[type="radio"]:checked');
    var isGray = selectedColour && /gr[ae]y/i.test(selectedColour.value);
    var src = isGray ? hero.dataset.graySrc : hero.dataset.blackSrc;
    hero.srcset = smileHeroSources(src);
    hero.sizes = '(min-width: 1200px) min(37vw, 750px), (min-width: 768px) 54vw, calc(100vw - 32px)';
    hero.src = sizedSmileAsset(src, 900);
    hero.alt = 'Smile Pro Ergonomic Chair in ' + (isGray ? 'Gray' : 'Black');
    hero.closest('[data-image]')?.setAttribute('data-image', src);
    var firstThumb = document.querySelector('[data-product-thumbnails] [data-thumb-index="0"] img');
    var modalImage = document.querySelector('.media--modal .swiper-slide:first-child img');
    [firstThumb, modalImage].forEach(function (image) {
      if (!image) return;
      image.removeAttribute('srcset');
      image.removeAttribute('data-src');
      image.removeAttribute('data-srcset');
      image.src = src;
      image.alt = hero.alt;
    });
  }
  syncHero();
  window.addEventListener('load', syncHero, { once: true });
  form.addEventListener('change', function (event) {
    if (event.target.matches('.product_swatches input[type="radio"]')) syncHero();
  });

  document.querySelectorAll('a[href*="view=creator-partners"]').forEach(function (link) {
    if (link.closest('header')) link.querySelectorAll('span').forEach(function (span) { span.textContent = 'Creator Partners'; });
    if (link.closest('header') && !link.querySelector('span')) link.textContent = 'Creator Partners';
  });
  var cartLink = document.querySelector('header #HeaderCart');
  if (cartLink && !document.querySelector('.smile-pro-shop-now')) {
    var shopNow = document.createElement('a');
    shopNow.className = 'smile-pro-shop-now';
    shopNow.href = '/collections/all-products';
    shopNow.innerHTML = '<span>Shop Now</span><span class="smile-pro-shop-now__arrow" aria-hidden="true">→</span>';
    cartLink.parentNode.insertBefore(shopNow, cartLink);
  }

  var addOn = form.querySelector('.smile-pro-addon__checkbox');
  var addOnCard = form.querySelector('.smile-pro-addon__card');
  var price = form.querySelector('[data-smile-addon-price]');
  form.querySelectorAll('[data-smile-addon-variant]').forEach(function (swatch) {
    swatch.addEventListener('click', function () {
      if (!addOn) return;
      form.querySelectorAll('[data-smile-addon-variant]').forEach(function (item) {
        item.classList.toggle('is-active', item === swatch);
        item.setAttribute('aria-pressed', item === swatch ? 'true' : 'false');
      });
      addOn.dataset.id = swatch.dataset.smileAddonVariant;
      addOn.disabled = swatch.dataset.smileAddonAvailable !== 'true';
      if (addOn.disabled) addOn.checked = false;
      if (price) price.textContent = swatch.dataset.smileAddonPrice;
      if (addOnCard) addOnCard.classList.toggle('is-selected', addOn.checked);
    });
  });
  if (addOn) addOn.addEventListener('change', function () {
    if (addOnCard) addOnCard.classList.toggle('is-selected', addOn.checked);
  });

  var buyButton = form.querySelector('[data-smile-buy-now]');
  var error = form.querySelector('[data-smile-buy-error]');
  if (!buyButton) return;
  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) return;
    var addButton = form.querySelector('button[name="add"]');
    buyButton.disabled = !addButton || addButton.disabled || addButton.getAttribute('aria-disabled') === 'true';
  });
  if ('IntersectionObserver' in window) {
    function updateChatAvoidance() {
      var buyBounds = buyButton.getBoundingClientRect();
      document.body.classList.toggle('smile-pro-buy-in-view',
        window.innerWidth <= 767 && buyBounds.bottom > 0 && buyBounds.top < window.innerHeight);
    }
    var chatAvoidObserver = new IntersectionObserver(updateChatAvoidance);
    chatAvoidObserver.observe(buyButton);
    window.addEventListener('resize', updateChatAvoidance);
    updateChatAvoidance();
  }
  buyButton.addEventListener('click', async function () {
    if (buyButton.disabled) return;
    var data = new FormData(form);
    var id = Number(data.get('id'));
    var quantity = Math.max(1, Number(data.get('quantity')) || 1);
    if (!id) {
      if (error) { error.textContent = 'Please select a chair colour.'; error.hidden = false; }
      return;
    }
    var items = [{ id: id, quantity: quantity }];
    if (addOn && addOn.checked && !addOn.disabled) items.push({ id: Number(addOn.dataset.id), quantity: 1 });
    buyButton.disabled = true;
    if (error) error.hidden = true;
    try {
      var response = await fetch('/cart/add.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: items })
      });
      if (!response.ok) {
        var details = await response.json();
        throw new Error(details.description || 'Unable to add your selection.');
      }
      window.location.assign(window.ShappaHalloweenOffer?.checkoutUrl?.() || '/checkout');
    } catch (failure) {
      if (error) { error.textContent = failure.message || 'Please try again.'; error.hidden = false; }
      buyButton.disabled = false;
    }
  });
});
